import React from 'react';
import ReactDOM from 'react-dom';
import FormItemEditor from './FormItemEditor';
import FormItemConst from './FormItemConst';
import {RecordFieldChangeStore,AutoSaveBeforeStore} from '../stores/RecordsStore';
import RecordsActions from '../actions/RecordsActions';
import FocusActions from '../actions/FocusActions';
import FormItemTimeResolver from './resolver/FormItemTimeResolver';
import FormItemTimeDisplay from './display/FormItemTimeDisplay';
import Fade from '../utils/Fade';

require('../styles/FormItemTime.css');

export default class FormItemTimeEditor extends FormItemEditor
{
	constructor(props) {
		super(props);
		this.initMembers();
		this.initStores();
	}

	initMembers()
	{
		
		this.lookupEvents = [
			[$(document), {
				'mousedown touchstart': $.proxy(function(e){
					console.log("执行到了注册的事件侦听 是否已卸载");					
					if (!(
						$(this.inputFieldContainer).is(e.target) ||
						$(this.inputFieldContainer).find(e.target).length ||
						this.dropdownform.is(e.target) ||
						this.dropdownform.find(e.target).length
					)){
						this.closeDropDown();
					}
				}, this)
			}]
		];
		
	}

	initStores()
	{
		if(!this.props.forLookup)
		{
			this.unsubscribeRecordFieldChangeStore = RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
			this.unsubscribeAutoSaveBeforeStore = AutoSaveBeforeStore.listen(this.onBeforeAutoSave.bind(this));
		}
		
	}

	componentWillUnmount()
	{
		this.distroyCommonStores();
		if(!this.props.forLookup)
		{
			if(typeof(this.unsubscribeRecordFieldChangeStore) == "function")
				this.unsubscribeRecordFieldChangeStore();
			if(typeof(this.unsubscribeAutoSaveBeforeStore) == "function")
				this.unsubscribeAutoSaveBeforeStore();
		}
	}
	
	onCurrentRecordChanged(records,currentRecord,groupAlias,moduleInstanceId)
	{
		super.onCurrentRecordChanged(records,currentRecord,groupAlias,moduleInstanceId);
		if(this.props.underQueryGroup){
			return;
		}
		if(this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId)
		{
			this.currentDataFieldChanged = false;			
			this.doSetModifiedTagNone();
			if(this.props.dataField)
			{
				var _value = this.record?this.record[this.props.dataField]:'';
			}
			else
			{
				_value = this.record;
			}
			//var _value = (this.record&&this.props.dataField)?this.record[this.props.dataField]:"";
			this.setDisplay(_value);
			if(this.props.control)
			{

				var _allowEdit = true;
				if(!this.record && groupAlias)
				{
					_allowEdit = false;
				}
				else
				{
					_allowEdit = this.props.control.getProperty_AllowEdit_Final(this.record);
				}
				this.doSetEnable(_allowEdit);	
			}
		}
	}

	onDataFieldChanged(record,dataField,oldValue,newValue,observer)
	{
		if(observer != this && this.props.dataField == dataField && record == this.record)
		{
			this.setDisplay(newValue);
			this.updateModifiedTag();
		}
		//else 
		//	alert("observer is this!");
	}

	componentDidMount()
	{
		super.componentDidMount();
		//super.componentDidMount();
		 //此处跟Flex有差别 无法精确判断焦点关联对象 relatedTarget只有在文本框类dom节点才有值 否则为null
		 //不能获得焦点的比如下拉框div仍然可以使得input失去焦点
		 /*$(this.refs.inputdomtime).blur(function(event){
		 	  
		  	  $(this).val("06-06");
		 });*/
		 let _initRecord;
		 if(this.props.dataField)
		 {
			 _initRecord = this.props.initRecord;
		 }
		 else
		 {
		 	if(this.props.control.hasInitEditorValue)
			{
				_initRecord = this.props.initEditorValue;	
			}
			else
			{
				_initRecord = this.props.initRecord;
			}
			//_initRecord = this.props.initEditorValue;
		 }
		this.onCurrentRecordChanged(null,_initRecord,this.props.groupAlias,this.props.moduleInstanceId);
		$(this.contextMenuHandler).contextPopup(this.props.contextMenuData);
	}

	doSetEnable(enable)
	{
		var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
		if(nowAllowEdit == true && enable == false)
		{
			this.setState({allowEdit:false});
		}
		else if(nowAllowEdit == false && enable == true)
		{
			this.setState({allowEdit:true});
		}
	}

	onBeforeAutoSave(groupAlias)
	{
		if(this.props.groupAlias != groupAlias)
			return;
		if($(this.inputField).is(document.activeElement) || $(this.inputField).find(document.activeElement).length)
		{
			var text = $(this.inputField).val();
			var _val = FormItemTimeResolver.getResult(text,false);
			if(_val.indexOf("false:") == 0)
			{
				alert(_val.substr(6));
				return;
			}
			if(this.props.groupAlias == "")
			{
				this.record = _val;
			}
			else
			{
				let changed = false;
				let oldValue = this.record[this.props.dataField];
				let newValue = _val;
				if(oldValue != newValue)
					changed = true;
				this.record[this.props.dataField] = newValue;
				//alert("派发");	
				if(changed)	
				{
					RecordsActions.RecordFieldChanged(this.record,this.props.dataField,oldValue,newValue,this);
					if(this.props.control)this.props.control.doFieldModifiedRemote(this.props.dataField,newValue+"",oldValue+"");
				}
				this.updateModifiedTag();	
			}
		}
		return true;
	}

	setFinalValue(value,triggerModified = true)
	{
		if(this.props.underQueryGroup){
			var reg = "^[ ]+$";
			var rege = new RegExp(reg);
			if(rege.test($(this.inputField).val())){
				$(this.inputField).val('-只查空值-');
				this.record = '-只查空值-';
				value='-只查空值-';
				this.state.nullValue = true;
			}else if($(this.inputField).val() == '-只查空值-' || $(this.inputField).val()=='-'){
				$(this.inputField).val('-只查空值-');
				value='-只查空值-';
			}else if(value=='-点此填值-'){
				$(this.inputField).val('-点此填值-');
				value='';
			}else{
				if(!value)
				value = $(this.inputField).val();
			value = FormItemTimeResolver.getResult(value,false);
			}
		}else{
			if(!value)
				value = $(this.inputField).val();
			value = FormItemTimeResolver.getResult(value,false);
		}
		if(value.indexOf("false:") == 0)
		{
			Fade.show(value.substr(6));
			return FormItemConst.EDITOR_VALUE_CHANGED_ERROR;
		}
		if(!this.props.dataField)
		{
			if(this.props.groupAlias == "" || !this.props.groupAlias)
			{
				var oldValue = this.record;var newValue = value;this.record = value;
			
				if(this.props.control && oldValue != newValue && triggerModified)
				{
					this.props.control.doModifiedEditor(oldValue, newValue);
				}
			}
			this.record = value;
		}
		else
		{
			let changed = false;
			let oldValue = (this.record&&this.props.dataField)?this.record[this.props.dataField]:(this.record?this.record:"");
			let newValue = value;
			if(oldValue != newValue)
				changed = true;
			this.record[this.props.dataField] = newValue;
			//alert("派发");	
			if(changed)	
			{
				RecordsActions.RecordFieldChanged(this.record,this.props.dataField,oldValue,newValue,this);
				if(this.props.control)this.props.control.doFieldModifiedRemote(this.props.dataField,newValue+"",oldValue+"");
			}
			this.updateModifiedTag();	
		}

		return FormItemConst.EDITOR_VALUE_CHANGED_SUC;
		
	}

	inputFieldBlur()
	{
		if(this.lookupStates && this.lookupStates.isShowed)
		{
			return;
		}
		if(this.props.underQueryGroup && $(this.inputField).val()==""){
			this.state.notNull = false
			this.setState({allowEdit:false,nullValue:false})
			this.inQueryGroup = false;
		}else{
			if(this.props.control && this.props.control.getProperty_AllowEdit_Final() == true)
			{
				this.setFinalValue();
				//todo 值回送数据完成以后 严格按照显示要求再进行显示
				this.setDisplay();
			}
		}

		if(this.holdFocus)
		{
			$(this.inputField).focus();
			$(this.inputField).select();
		}
			
	}

	setDisplay(value)
	{
		if(this.props.underQueryGroup && this.record == '-只查空值-'){
			return;
		}
		if(value == undefined || value == null)
		{
			if(this.props.dataField && this.record)
				value = this.record[this.props.dataField];
			else
				value = this.record;
		}

		//let _displayStyle = this.props.control.getProperty_DisplayStyle();
		let _dislayFormat = this.props.displayFormat;
		if(_dislayFormat)
		{
			value = FormItemTimeDisplay.getDisplayText2(value,_dislayFormat);
		}
		else
		{
			value = FormItemTimeDisplay.getDisplayText(value,this.props.showHour,this.props.showMinute,this.props.showSecond);
		}

		$(this.inputField).val(value);
	}

	closeDropDown()
	{
		if(this.dropDownShowed)
		{

			let lookupdiv = this.dropdownform;
			if(lookupdiv == null)
				return;
			this.detachEventListeners();
			
			lookupdiv.remove();
			this.dropDownShowed = false;
			this.dropdownform = null;
			this.focusByCloseDropDrown = true;
			this.inputField.focus();
			this.inputField.select();
			return false;	
		}

	}

	showDropDown()
	{
		if(this.dropDownShowed == true)
		{
			this.closeDropDown();
			return;
		}
		let $dropdown = this.getDropDownHtml();
		$('body').append($dropdown);

		let nowVal = this.record;
		if(this.record && typeof(this.record) == "string")
		{
			let hourLis = $(".dateTimeWrap #selHour>ol>li");
			let minuteList = $(".dateTimeWrap #selMinute>ol>li");
			let secondsList = $(".dateTimeWrap #selSecond>ol>li");
			let _arr = nowVal.split(":");
			let nowHour = _arr[0];let nowMinute = _arr[1];let nowSecond = _arr[2];
			for(let i = 0;i<hourLis.length;i++)
			{
				let item = hourLis[i];
				if($(item).html() == nowHour)
				{
					hourLis.removeClass("cur");
					$(item).addClass("cur");
					$(item).parent().scrollTop($(item).offset().top - $(item).height());
					break;
				}
			}

			for(let k = 0;k<minuteList.length;k++)
			{
				let item = minuteList[k];
				if($(item).html() == nowMinute)
				{
					minuteList.removeClass("cur");
					$(item).addClass("cur");
					$(item).parent().scrollTop($(item).offset().top - $(item).height());
					break;
				}
			}
			for(let k = 0;k<secondsList.length;k++)
			{
				let item = secondsList[k];
				if($(item).html() == nowSecond)
				{
					secondsList.removeClass("cur");
					$(item).addClass("cur");
					$(item).parent().scrollTop($(item).offset().top - $(item).height());
					break;
				}
			}
		}
		

		this.dropdownform = $dropdown;
		var lookupdiv = $dropdown;
		var _inputwidth = $(this.inputField).width();//this.props.displayLengthWidth;
		var _iframewidth = lookupdiv.outerWidth();
		
		var _iframeheight = lookupdiv.outerHeight();
		
		var _gwidth = $("#app").width();
		var _gheight = $("#app").height();

		if(_iframewidth>_gwidth)
		{
			_iframewidth = _gwidth;
			lookupdiv.css({width:_iframewidth+'px',overflow:"auto"});
		}
		var _offset = $(this.inputField).offset();
		var _y = _offset.top; 
		var _x = _offset.left;
		var _top = _y+$(this.inputField).height();
		//alert('x:'+_x+'y:'+_y);
		//下方屏幕放不下
		if((_top+_iframeheight)>_gheight)
		{
			//上下都放不下 考虑缩减高度
			if(_iframeheight>_y)
			{
				//上方空间大
				if(_y>(_gheight/2))
				{
					lookupdiv.height(_y-2);
					_top = '0px';
				}
				else //下方空间大
				{
					lookupdiv.css("height",(_gheight-_top)+'px');	
				}
			}
			else//下拉框置于上方
			{
				_top = (_y-_iframeheight)+'px';
			}
		}
		var _left = _x-((_iframewidth-_inputwidth)/2);
			//(_iframewidth-_inputwidth)/2;
		if(_left+_iframewidth>_gwidth)
			_left = _gwidth-_iframewidth-5;
		if(_left<0)_left = 0;
		
		lookupdiv.css({left:(_left+'px'),top:_top});
		this.dropDownShowed = true;
		this.inQueryGroup = true;
		this.attachEventListeners();
	}

	attachEventListeners()
	{
		this.unapplyEvents(this.lookupEvents);
		this.applyEvents(this.lookupEvents);

		this.dropdownform.find("ul>li>ol>li").on("click",this.timeLiClickHandler.bind(this));
		this.dropdownform.find("#ensure").on("click",this.timeEnsureHandler.bind(this));
		this.dropdownform.find("#curTime").on("click",this.timeNowEnsureHandler.bind(this));
	}

	detachEventListeners()
	{
		this.unapplyEvents(this.lookupEvents);
		this.dropdownform.find("ul>li>ol>li").off();
		this.dropdownform.find("#ensure").off();
		this.dropdownform.find("#curTime").off();
	}

	timeLiClickHandler(e)
	{
		$(e.target).parent().find("li").removeClass("cur");
		$(e.target).addClass("cur");
	}

	timeEnsureHandler(e)
	{
		let selectedLi = this.dropdownform.find("li.cur");
		let timeStr = "";
		for(let i = 0;i<selectedLi.length;i++)
		{
			let li = $(selectedLi[i]);
			timeStr = timeStr + li.text() + ":";
		}
		timeStr = timeStr.substring(0,timeStr.length-1);
		if(timeStr.split(":").length<3){
			timeStr+=":00";
		}
		$(this.inputField).val(timeStr);
		this.closeDropDown();
	}

	timeNowEnsureHandler(e)
	{
		let _date = new Date();
       
		var hours = _date.getHours();
		if(hours<10)
			hours = "0"+hours;
		var minutes = _date.getMinutes();
		if(minutes<10)
			minutes = "0"+minutes;
		var seconds =_date.getSeconds();
		if(seconds<10)
			seconds = "0"+seconds;
		let timeStr = hours+":"+minutes+":"+seconds;
		$(this.inputField).val(timeStr);
		this.closeDropDown();
	}

	applyEvents(evs)
	{
		for (var i=0, el, ch, ev; i < evs.length; i++)
		{
			el = evs[i][0];
			if (evs[i].length === 2){
				ch = undefined;
				ev = evs[i][1];
			}
			else if (evs[i].length === 3){
				ch = evs[i][1];
				ev = evs[i][2];
			}
			el.on(ev, ch);
		}
	}

	unapplyEvents(evs)
	{
		for (var i=0, el, ev, ch; i < evs.length; i++)
		{
			el = evs[i][0];
			if (evs[i].length === 2){
				ch = undefined;
				ev = evs[i][1];
			}
			else if (evs[i].length === 3){
				ch = evs[i][1];
				ev = evs[i][2];
			}
			el.off(ev, ch);
		}
	}

	inputFieldFocus()
	{
		if(this.focusByCloseDropDrown == true)
		{
			this.focusByCloseDropDrown = false;
			return;
		}
		window.lastFocusUI = this.inputField;
		if(this.props.groupAlias)
			window.lastEditedDataFields[this.props.groupAlias] = this.props.dataField;
		FocusActions.currentGroupSet(this.props.groupAlias,this.props.formId);
		if(this.props.underQueryGroup && this.record=='00:00:00'){
			this.record='';
		}
		if(!this.props.dataField)
		{
			$(this.inputField).val(this.record);
		}
		else
		{
			let _recordValue = this.record==null?"":this.record[this.props.dataField];
			$(this.inputField).val(_recordValue);	
		}
		if(this.state.underQueryGroup){
			if($(this.inputField).val() == '-只查空值-'){
				$(this.inputField).val('');
				this.record='';
			}
		}
		var _parentWindow =window;	
		if(_parentWindow.notClickFocusEditor){
			_parentWindow =window;
		}else if(window.parent.window.notClickFocusEditor){
			_parentWindow =window.parent.window;
		}
		if(_parentWindow.notClickFocusEditor == undefined || (!_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors == '')
			|| (!_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors.indexOf(this.inputField.parentElement.parentElement.id) == -1 )){
			$(this.inputField).select();
		}
	}

	onKeyDownHandler(e)
	{
		if(super.onKeyDownHandler(e))
			return;
		if(!e.ctrlKey &&e.keyCode>64&&e.keyCode<91)
		{
			e.preventDefault();
		}
	}

	getDropDownHtml()
	{
		return $('<div class="dateTimeWrap" style="padding-top:0px;background: #FFFFFF;border: 1px solid #CDCDCD;box-shadow: 0 2px 6px 0 rgba(0,0,0,0.14);border-radius: 2px;display: block;height: 240px; width: 180px;"><div class="timePart" style=""><ul style="display:flex;padding-left: 0px;border-top:none;margin-bottom:7px"><li id="selHour"><p>时</p><ol style="border-right:none;"><li class="cur">00</li><li>01</li><li>02</li><li>03</li><li>04</li><li>05</li><li>06</li><li>07</li><li>08</li><li>09</li><li>10</li><li>11</li><li>12</li><li>13</li><li>14</li><li>15</li><li>16</li><li>17</li><li>18</li><li>19</li><li>20</li><li>21</li><li>22</li><li>23</li></ol></li><li id="selMinute"><p>分</p><ol><li class="cur">00</li><li>01</li><li>02</li><li>03</li><li>04</li><li>05</li><li>06</li><li>07</li><li>08</li><li>09</li><li>10</li><li>11</li><li>12</li><li>13</li><li>14</li><li>15</li><li>16</li><li>17</li><li>18</li><li>19</li><li>20</li><li>21</li><li>22</li><li>23</li><li>24</li><li>25</li><li>26</li><li>27</li><li>28</li><li>29</li><li>30</li><li>31</li><li>32</li><li>33</li><li>34</li><li>35</li><li>36</li><li>37</li><li>38</li><li>39</li><li>40</li><li>41</li><li>42</li><li>43</li><li>44</li><li>45</li><li>46</li><li>47</li><li>48</li><li>49</li><li>50</li><li>51</li><li>52</li><li>53</li><li>54</li><li>55</li><li>56</li><li>57</li><li>58</li><li>59</li></ol></li><li id="selSecond"><p>秒</p><ol><li class="cur">00</li><li>01</li><li>02</li><li>03</li><li>04</li><li>05</li><li>06</li><li>07</li><li>08</li><li>09</li><li>10</li><li>11</li><li>12</li><li>13</li><li>14</li><li>15</li><li>16</li><li>17</li><li>18</li><li>19</li><li>20</li><li>21</li><li>22</li><li>23</li><li>24</li><li>25</li><li>26</li><li>27</li><li>28</li><li>29</li><li>30</li><li>31</li><li>32</li><li>33</li><li>34</li><li>35</li><li>36</li><li>37</li><li>38</li><li>39</li><li>40</li><li>41</li><li>42</li><li>43</li><li>44</li><li>45</li><li>46</li><li>47</li><li>48</li><li>49</li><li>50</li><li>51</li><li>52</li><li>53</li><li>54</li><li>55</li><li>56</li><li>57</li><li>58</li><li>59</li></ol></li></ul><div class="timeFooter"><span id="ensure">确定</span><span id="curTime">当前时间</span></div></div></div>');
	}
	showDropFocus(){
		if(this.props.underQueryGroup){
			this.setState({allowEdit:true});
			$(this.inputField).val('');
			this.record='';
			this.showDropDown();
		}
	}

	getDownArrowButtonDom()
	{
		if(this.state.allowEdit)
		{
			if(this.props.underQueryGroup){
				return <i ref={node => this.downArrowButton = node} onClick={this.showDropDown.bind(this)} className="fa fa-clock-o" style={{position:'absolute',top:'calc(100% / 2 - 5px)',left:'calc(100% - 13px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>;
			}else{
				return <i ref={node => this.downArrowButton = node} onClick={this.showDropDown.bind(this)} className="fa fa-clock-o" style={{display:'none',position:'absolute',top:'calc(100% / 2 - 5px)',left:'calc(100% - 13px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>;
			}
			
		}
		else
		{
			if(this.props.underQueryGroup){
				return <i ref={node => this.downArrowButton = node} onClick={this.showDropFocus.bind(this)} className="fa fa-clock-o" style={{position:'absolute',top:'calc(100% / 2 - 5px)',left:'calc(100% - 13px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>
			}else{
				return <i ref={node => this.downArrowButton = node} onClick={this.showDropFocus.bind(this)} className="fa fa-clock-o" style={{display:'none',position:'absolute',top:'calc(100% / 2 - 5px)',left:'calc(100% - 13px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>
			}
			
		}
	}
	inputCloseOnClick(){
		$(this.inputField).val('');
		this.record='';
		this.setState({allowEdit:false,nullValue:false})
		this.inQueryGroup = false;
	}
	inputFieldOnClick(){
		if(this.props.underQueryGroup){
			this.state.notNull = false
			this.setState({allowEdit:true,nullValue:false})
			this.inQueryGroup = true;
		}
	}

	getInputDom(_width)
	{
		if(this.state.allowEdit)
		{
			let height = this.props.height?this.props.height:FormItemConst.EDITOR_HEIGHT;
			if(this.props.displayHeight){
				height = this.props.height?this.props.height:FormItemConst.EDITOR_HEIGHT*(Number(this.props.displayHeight));
			}
			let _style = {padding:'2px 13px 2px 2px',height:(height)+'px',width:_width,fontSize:"12px"};
			_style.textAlign = this.props.textAlign.toLowerCase();
			if(this.props.cssStyle)
			{
				Object.assign(_style,this.props.cssStyle);
			}
			if(this.state.color && this.state.color != -1)_style.color = this.state.color;
			if(this.state.backgroundColor && this.state.backgroundColor != -1)_style.backgroundColor = this.state.backgroundColor;
			if(this.state.fontSize && this.state.fontSize != -1)_style.fontSize = this.state.fontSize;
			if(this.state.fontFamily)_style.fontFamily = this.state.fontFamily;
			if(this.state.fontWeight)_style.fontWeight = this.state.fontWeight;
			if(this.props.customStyle)Object.assign(_style,this.props.customStyle);

			if(this.props.underQueryGroup){

				_style.border ='none'
				_style.height =parseInt(height)-2+'px';
				_width = _width.replace('px','');
				_style.width=parseInt(_width)+11+'px';

				return	<div style={{position:'relative',width:'100%',height:'22px',marginRight:'12px',border:'1px solid #ccc'}} >
							<input spellCheck="false" autoComplete="off" ref={node => this.inputField = node} id={"input"+this.props.xml.id} type="text" 
								className="form-control" style={_style}
								onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)}/>
							<i className="fa fa-times-circle" style={{position: 'absolute',right: '14px',top:'5px',zIndex:'1000',color:'gray',fontSize:'1px'}} onClick={this.inputCloseOnClick.bind(this)}></i>	
						</div>

			}else{
				return	<input spellCheck="false" autoComplete="off" ref={node => this.inputField = node} id={"input"+this.props.xml.id} type="text" 
				className="form-control" style={_style}
				onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)}/>;
			}

		}
		else
		{
			let height = this.props.height?this.props.height:FormItemConst.EDITOR_HEIGHT;
			if(this.props.displayHeight){
				height = this.props.height?this.props.height:FormItemConst.EDITOR_HEIGHT*(Number(this.props.displayHeight));
			}
			let _style = {padding:'2px 13px 2px 2px',height:(height)+'px',width:_width,backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR,fontSize:"12px"};
			_style.textAlign = this.props.textAlign.toLowerCase();
			if(this.props.cssStyle)
			{
				Object.assign(_style,this.props.cssStyle);
			}
			if(this.state.color && this.state.color != -1)_style.color = this.state.color;
			if(this.state.fontSize && this.state.fontSize != -1)_style.fontSize = this.state.fontSize;
			if(this.state.fontFamily)_style.fontFamily = this.state.fontFamily;
			if(this.state.fontWeight)_style.fontWeight = this.state.fontWeight;
			if(this.props.customStyle)Object.assign(_style,this.props.customStyle);



			if(this.props.underQueryGroup){
				_width = _width.replace('px','');
				_style.width=parseInt(_width)+25+'px';
				let defaultValue='-点此填值-';
				_style.textAlign='center';
				return <div >
				<input spellCheck="false" autoComplete="off" ref={node => this.inputField = node} id={"input"+this.props.xml.id} type="text" readOnly="readonly" 
			        	   className="form-control" style={_style}
			        	   onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)} value={defaultValue} onClick={this.inputFieldOnClick.bind(this)}/>
				<i className="fa fa-times-circle" style={{position: 'absolute',right: '14px',top:'3px',zIndex:'1000',display:'none'}} onClick={this.inputCloseOnClick.bind(this)}></i>	
				</div>


			}else{
				_style.paddingRight='2px'
			return	 <input spellCheck="false" autoComplete="off" ref={node => this.inputField = node} id={"input"+this.props.xml.id} type="text" readOnly="readonly" 
			className="form-control" style={_style}
			onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)}/>
		
						}


		}
	}
	showDownArrow(){
		if(this.props.underQueryGroup){return}
		if(this.state.allowEdit){
			$(this.downArrowButton).show();
		}
	}
	hideDownArrow(){
		if(this.props.underQueryGroup){return}
		if(this.state.allowEdit){
			$(this.downArrowButton).hide();
		}
	}

	render()
	{
		let inputWidth = this.props.displayLengthWidth + "px";
		let _display = this.currentDataFieldChanged?"block":"none";
		let displayLength=this.state.displayLength;
		let _width=displayLength*FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon+'px';
		let notNull=this.state.notNull;
		var _notNullStyle={};
		_notNullStyle['fontSize']='8px';
    	_notNullStyle['color']='red';
		if(!notNull){
			_notNullStyle['visibility']='hidden';
		}else if(this.props.underQueryGroup){
			_notNullStyle['visibility']='hidden';
		}

		let editorStyle = {display:'flex',flexDirection:'row',alignItems:'center'};
		if(this.state.visible == false)
			if(this.state.hideInVisible == true) editorStyle.display="none"; else editorStyle.visibility="hidden";
		
		let widthProValue = this.props.control.getProperty_Width();
		let middleStyle = {position:"relative"};
		if(widthProValue && widthProValue.indexOf && widthProValue.indexOf("%") != -1)
		{
			_width = "100%";middleStyle.width = widthProValue;editorStyle.width = "100%";
		}

		let inputdom = this.getInputDom(_width);
		let dropDownButton = this.getDownArrowButtonDom();
		let labelStyle = {paddingLeft:'5px',width:'auto',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px'};
		// if(this.state.underQueryGroup && !this.inQueryGroup)
		// {
		// 	labelStyle.cursor = "pointer";labelStyle.color = "#CFCFCF";
		// }
		if(!this.state.label){labelStyle.display = "none";_notNullStyle.display = "none"}
		return(

			<div id={this.props.xml.name} ref={node=>this.contextMenuHandler=node} className='editorGroup' style={editorStyle}>
				<label htmlFor={"input"+this.props.xml.id} className="fieldGroupLabel" ref={node => this.componentLabel = node} style={labelStyle} onClick={this.labelClickHandler.bind(this)}>
					{this.state.label}
					
				</label>
				<i className='fa fa-snowflake-o' style={_notNullStyle}></i>
				<div style={middleStyle} ref={node=>this.inputFieldContainer = node} onMouseEnter={this.showDownArrow.bind(this)} onMouseLeave={this.hideDownArrow.bind(this)} >
			        {inputdom}{dropDownButton}
			       	<i ref={node => this.modifiedTag = node} className="fa fa-sort-asc" aria-hidden="true" style={{color:"red",position:"absolute",top:"-5px",right:"-3px",fontSize:"11px",transform:'rotate(45deg)',zIndex:"100",marginRight:'4.5px',marginTop:'4px',display:_display}}></i>
			    </div>
			</div>

			/*<div className="form-group" style={{marginRight:'auto'}}>
			  <label className="col-sm-2 control-label" style={{paddingLeft:'5px',paddingRight:'5px',width:'auto'}}>{this.props.xml.name}</label>
			  <div className="col-sm-10" style={{width:'auto',paddingLeft:'5px'}}>
		        <input ref='inputdomtime' type="text" className="form-control" style={{padding:'2px',width:inputWidth}}></input>
			  </div>
			</div>*/
		);
	}
}



// WEBPACK FOOTER //
// ./src/formItem/FormItemTimeEditor.js